module.exports = __webpack_public_path__ + "static/media/security-check_3.39d4c4f2.png";